/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    MelcoCoreModelsBoolResponse,
    MelcoCoreModelsBoolResponseFromJSON,
    MelcoCoreModelsBoolResponseToJSON,
    MelcoCoreModelsControlCenterAppSetting,
    MelcoCoreModelsControlCenterAppSettingFromJSON,
    MelcoCoreModelsControlCenterAppSettingToJSON,
    MelcoCoreModelsDRMCancelSerialNumber,
    MelcoCoreModelsDRMCancelSerialNumberFromJSON,
    MelcoCoreModelsDRMCancelSerialNumberToJSON,
    MelcoCoreModelsDRMGenerateSerialNumber,
    MelcoCoreModelsDRMGenerateSerialNumberFromJSON,
    MelcoCoreModelsDRMGenerateSerialNumberToJSON,
    MelcoCoreModelsEfsSettingEfsDefaultAppSetting,
    MelcoCoreModelsEfsSettingEfsDefaultAppSettingFromJSON,
    MelcoCoreModelsEfsSettingEfsDefaultAppSettingToJSON,
    MelcoCoreModelsError,
    MelcoCoreModelsErrorFromJSON,
    MelcoCoreModelsErrorToJSON,
    MelcoCoreModelsFusionDefaultAppSetting,
    MelcoCoreModelsFusionDefaultAppSettingFromJSON,
    MelcoCoreModelsFusionDefaultAppSettingToJSON,
    MelcoCoreModelsGenericList1MelcoCoreModelsDRMSerialNumberListItem,
    MelcoCoreModelsGenericList1MelcoCoreModelsDRMSerialNumberListItemFromJSON,
    MelcoCoreModelsGenericList1MelcoCoreModelsDRMSerialNumberListItemToJSON,
    MelcoCoreModelsGenericList1MelcoCoreModelsDocContent,
    MelcoCoreModelsGenericList1MelcoCoreModelsDocContentFromJSON,
    MelcoCoreModelsGenericList1MelcoCoreModelsDocContentToJSON,
    MelcoCoreModelsGenericList1MelcoCoreModelsProductListItem,
    MelcoCoreModelsGenericList1MelcoCoreModelsProductListItemFromJSON,
    MelcoCoreModelsGenericList1MelcoCoreModelsProductListItemToJSON,
    MelcoCoreModelsGenericList1MelcoCoreModelsProductPermissions,
    MelcoCoreModelsGenericList1MelcoCoreModelsProductPermissionsFromJSON,
    MelcoCoreModelsGenericList1MelcoCoreModelsProductPermissionsToJSON,
    MelcoCoreModelsGenericList1MelcoCoreModelsProductVersionListItem,
    MelcoCoreModelsGenericList1MelcoCoreModelsProductVersionListItemFromJSON,
    MelcoCoreModelsGenericList1MelcoCoreModelsProductVersionListItemToJSON,
    MelcoCoreModelsGenericList1MelcoCoreModelsRole,
    MelcoCoreModelsGenericList1MelcoCoreModelsRoleFromJSON,
    MelcoCoreModelsGenericList1MelcoCoreModelsRoleToJSON,
    MelcoCoreModelsGenericList1MelcoCoreModelsSubscriptionListItem,
    MelcoCoreModelsGenericList1MelcoCoreModelsSubscriptionListItemFromJSON,
    MelcoCoreModelsGenericList1MelcoCoreModelsSubscriptionListItemToJSON,
    MelcoCoreModelsProductResponse,
    MelcoCoreModelsProductResponseFromJSON,
    MelcoCoreModelsProductResponseToJSON,
    MelcoCoreModelsUpdateProduct,
    MelcoCoreModelsUpdateProductFromJSON,
    MelcoCoreModelsUpdateProductToJSON,
} from '../models';

export interface SystemManagementApiGetRolesRequest {
    offset?: number;
    limit?: number;
    sortBy?: string | null;
    searchText?: string | null;
}

export interface SystemManagementApiProductLicensesCancelRequest {
    serialNumber: string | null;
    melcoCoreModelsDRMCancelSerialNumber?: MelcoCoreModelsDRMCancelSerialNumber;
}

export interface SystemManagementApiProductLicensesExportRequest {
    searchText?: string | null;
    serialNumber?: string | null;
    productCodes?: string | null;
    subscriptionCode?: string | null;
    referralCode?: string | null;
    batch?: string | null;
    cancelled?: string | null;
    offset?: number;
    limit?: number;
    sortBy?: string | null;
    versionId?: string | null;
}

export interface SystemManagementApiProductLicensesGenerateRequest {
    melcoCoreModelsDRMGenerateSerialNumber?: MelcoCoreModelsDRMGenerateSerialNumber;
}

export interface SystemManagementApiProductLicensesSearchRequest {
    searchText?: string | null;
    serialNumber?: string | null;
    productCodes?: string | null;
    subscriptionCode?: string | null;
    referralCode?: string | null;
    batch?: string | null;
    cancelled?: string | null;
    offset?: number;
    limit?: number;
    sortBy?: string | null;
    versionId?: string | null;
    typeList?: string | null;
}

export interface SystemManagementApiProductPermissionsRequest {
    productCodeList?: string | null;
}

export interface SystemManagementApiProductsDocumentRequest {
    productCode: string | null;
    id: string | null;
    lang?: string | null;
}

export interface SystemManagementApiProductsEditProductRequest {
    productCode: string | null;
    melcoCoreModelsUpdateProduct?: MelcoCoreModelsUpdateProduct;
}

export interface SystemManagementApiProductsGetListRequest {
    searchText?: string | null;
    offset?: number;
    limit?: number;
    sortBy?: string | null;
}

export interface SystemManagementApiProductsGetModuleListRequest {
    productCodeList?: string | null;
    versionNumberList?: string | null;
}

export interface SystemManagementApiProductsGetProductRequest {
    productCode: string | null;
}

export interface SystemManagementApiProductsGetVersionListRequest {
    productCode: string | null;
    searchText?: string | null;
    offset?: number;
    limit?: number;
    sortBy?: string | null;
}

export interface SystemManagementApiProductsPdfDocumentRequest {
    productCode: string | null;
    id: string | null;
    download?: boolean;
}

/**
 * 
 */
export class SystemManagementApi extends runtime.BaseAPI {

    /**
     * get roles
     */
    async getRolesRaw(requestParameters: SystemManagementApiGetRolesRequest): Promise<runtime.ApiResponse<MelcoCoreModelsGenericList1MelcoCoreModelsRole>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/roles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoCoreModelsGenericList1MelcoCoreModelsRoleFromJSON(jsonValue));
    }

    /**
     * get roles
     */
    async getRoles(requestParameters: SystemManagementApiGetRolesRequest): Promise<MelcoCoreModelsGenericList1MelcoCoreModelsRole> {
        const response = await this.getRolesRaw(requestParameters);
        return await response.value();
    }

    /**
     * cancel serial number
     * cancel serial number
     */
    async productLicensesCancelRaw(requestParameters: SystemManagementApiProductLicensesCancelRequest): Promise<runtime.ApiResponse<MelcoCoreModelsBoolResponse>> {
        if (requestParameters.serialNumber === null || requestParameters.serialNumber === undefined) {
            throw new runtime.RequiredError('serialNumber','Required parameter requestParameters.serialNumber was null or undefined when calling productLicensesCancel.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/products/licenses/{serial_number}/cancel`.replace(`{${"serial_number"}}`, encodeURIComponent(String(requestParameters.serialNumber))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MelcoCoreModelsDRMCancelSerialNumberToJSON(requestParameters.melcoCoreModelsDRMCancelSerialNumber),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoCoreModelsBoolResponseFromJSON(jsonValue));
    }

    /**
     * cancel serial number
     * cancel serial number
     */
    async productLicensesCancel(requestParameters: SystemManagementApiProductLicensesCancelRequest): Promise<MelcoCoreModelsBoolResponse> {
        const response = await this.productLicensesCancelRaw(requestParameters);
        return await response.value();
    }

    /**
     * export licenses list
     * export licenses list
     */
    async productLicensesExportRaw(requestParameters: SystemManagementApiProductLicensesExportRequest): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.serialNumber !== undefined) {
            queryParameters['serial_number'] = requestParameters.serialNumber;
        }

        if (requestParameters.productCodes !== undefined) {
            queryParameters['product_codes'] = requestParameters.productCodes;
        }

        if (requestParameters.subscriptionCode !== undefined) {
            queryParameters['subscription_code'] = requestParameters.subscriptionCode;
        }

        if (requestParameters.referralCode !== undefined) {
            queryParameters['referral_code'] = requestParameters.referralCode;
        }

        if (requestParameters.batch !== undefined) {
            queryParameters['batch'] = requestParameters.batch;
        }

        if (requestParameters.cancelled !== undefined) {
            queryParameters['cancelled'] = requestParameters.cancelled;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.versionId !== undefined) {
            queryParameters['version_id'] = requestParameters.versionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products/licenses/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     * export licenses list
     * export licenses list
     */
    async productLicensesExport(requestParameters: SystemManagementApiProductLicensesExportRequest): Promise<Blob> {
        const response = await this.productLicensesExportRaw(requestParameters);
        return await response.value();
    }

    /**
     * generate serial numbers
     * generate serial numbers
     */
    async productLicensesGenerateRaw(requestParameters: SystemManagementApiProductLicensesGenerateRequest): Promise<runtime.ApiResponse<MelcoCoreModelsGenericList1MelcoCoreModelsDRMSerialNumberListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/products/licenses`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MelcoCoreModelsDRMGenerateSerialNumberToJSON(requestParameters.melcoCoreModelsDRMGenerateSerialNumber),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoCoreModelsGenericList1MelcoCoreModelsDRMSerialNumberListItemFromJSON(jsonValue));
    }

    /**
     * generate serial numbers
     * generate serial numbers
     */
    async productLicensesGenerate(requestParameters: SystemManagementApiProductLicensesGenerateRequest): Promise<MelcoCoreModelsGenericList1MelcoCoreModelsDRMSerialNumberListItem> {
        const response = await this.productLicensesGenerateRaw(requestParameters);
        return await response.value();
    }

    /**
     * get licenses list
     */
    async productLicensesSearchRaw(requestParameters: SystemManagementApiProductLicensesSearchRequest): Promise<runtime.ApiResponse<MelcoCoreModelsGenericList1MelcoCoreModelsDRMSerialNumberListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.serialNumber !== undefined) {
            queryParameters['serial_number'] = requestParameters.serialNumber;
        }

        if (requestParameters.productCodes !== undefined) {
            queryParameters['product_codes'] = requestParameters.productCodes;
        }

        if (requestParameters.subscriptionCode !== undefined) {
            queryParameters['subscription_code'] = requestParameters.subscriptionCode;
        }

        if (requestParameters.referralCode !== undefined) {
            queryParameters['referral_code'] = requestParameters.referralCode;
        }

        if (requestParameters.batch !== undefined) {
            queryParameters['batch'] = requestParameters.batch;
        }

        if (requestParameters.cancelled !== undefined) {
            queryParameters['cancelled'] = requestParameters.cancelled;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.versionId !== undefined) {
            queryParameters['version_id'] = requestParameters.versionId;
        }

        if (requestParameters.typeList !== undefined) {
            queryParameters['type_list'] = requestParameters.typeList;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products/licenses`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoCoreModelsGenericList1MelcoCoreModelsDRMSerialNumberListItemFromJSON(jsonValue));
    }

    /**
     * get licenses list
     */
    async productLicensesSearch(requestParameters: SystemManagementApiProductLicensesSearchRequest): Promise<MelcoCoreModelsGenericList1MelcoCoreModelsDRMSerialNumberListItem> {
        const response = await this.productLicensesSearchRaw(requestParameters);
        return await response.value();
    }

    /**
     * get permissions for products
     */
    async productPermissionsRaw(requestParameters: SystemManagementApiProductPermissionsRequest): Promise<runtime.ApiResponse<MelcoCoreModelsGenericList1MelcoCoreModelsProductPermissions>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.productCodeList !== undefined) {
            queryParameters['product_code_list'] = requestParameters.productCodeList;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products/permissions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoCoreModelsGenericList1MelcoCoreModelsProductPermissionsFromJSON(jsonValue));
    }

    /**
     * get permissions for products
     */
    async productPermissions(requestParameters: SystemManagementApiProductPermissionsRequest): Promise<MelcoCoreModelsGenericList1MelcoCoreModelsProductPermissions> {
        const response = await this.productPermissionsRaw(requestParameters);
        return await response.value();
    }

    /**
     * get api service default app settings
     * get api service default app settings
     */
    async productSettingsGetApiServiceAppSettingRaw(): Promise<runtime.ApiResponse<MelcoCoreModelsFusionDefaultAppSetting>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products/api_service/settings/app`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoCoreModelsFusionDefaultAppSettingFromJSON(jsonValue));
    }

    /**
     * get api service default app settings
     * get api service default app settings
     */
    async productSettingsGetApiServiceAppSetting(): Promise<MelcoCoreModelsFusionDefaultAppSetting> {
        const response = await this.productSettingsGetApiServiceAppSettingRaw();
        return await response.value();
    }

    /**
     * get control center app settings
     */
    async productSettingsGetControlCenterAppSettingRaw(): Promise<runtime.ApiResponse<MelcoCoreModelsControlCenterAppSetting>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products/control_center/settings/app`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoCoreModelsControlCenterAppSettingFromJSON(jsonValue));
    }

    /**
     * get control center app settings
     */
    async productSettingsGetControlCenterAppSetting(): Promise<MelcoCoreModelsControlCenterAppSetting> {
        const response = await this.productSettingsGetControlCenterAppSettingRaw();
        return await response.value();
    }

    /**
     * get efs default app settings
     * get efs default app settings
     */
    async productSettingsGetEfsAppSettingRaw(): Promise<runtime.ApiResponse<MelcoCoreModelsEfsSettingEfsDefaultAppSetting>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products/efs/settings/app`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoCoreModelsEfsSettingEfsDefaultAppSettingFromJSON(jsonValue));
    }

    /**
     * get efs default app settings
     * get efs default app settings
     */
    async productSettingsGetEfsAppSetting(): Promise<MelcoCoreModelsEfsSettingEfsDefaultAppSetting> {
        const response = await this.productSettingsGetEfsAppSettingRaw();
        return await response.value();
    }

    /**
     * get fusion default app settings
     * get fusion default app settings
     */
    async productSettingsGetFusionAppSettingRaw(): Promise<runtime.ApiResponse<MelcoCoreModelsFusionDefaultAppSetting>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products/fusion/settings/app`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoCoreModelsFusionDefaultAppSettingFromJSON(jsonValue));
    }

    /**
     * get fusion default app settings
     * get fusion default app settings
     */
    async productSettingsGetFusionAppSetting(): Promise<MelcoCoreModelsFusionDefaultAppSetting> {
        const response = await this.productSettingsGetFusionAppSettingRaw();
        return await response.value();
    }

    /**
     * get document (supported types: serviceterms)
     * get document
     */
    async productsDocumentRaw(requestParameters: SystemManagementApiProductsDocumentRequest): Promise<runtime.ApiResponse<MelcoCoreModelsGenericList1MelcoCoreModelsDocContent>> {
        if (requestParameters.productCode === null || requestParameters.productCode === undefined) {
            throw new runtime.RequiredError('productCode','Required parameter requestParameters.productCode was null or undefined when calling productsDocument.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling productsDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.lang !== undefined) {
            queryParameters['Lang'] = requestParameters.lang;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products/{product_code}/documents/{Id}`.replace(`{${"product_code"}}`, encodeURIComponent(String(requestParameters.productCode))).replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoCoreModelsGenericList1MelcoCoreModelsDocContentFromJSON(jsonValue));
    }

    /**
     * get document (supported types: serviceterms)
     * get document
     */
    async productsDocument(requestParameters: SystemManagementApiProductsDocumentRequest): Promise<MelcoCoreModelsGenericList1MelcoCoreModelsDocContent> {
        const response = await this.productsDocumentRaw(requestParameters);
        return await response.value();
    }

    /**
     * edit product
     * edit product
     */
    async productsEditProductRaw(requestParameters: SystemManagementApiProductsEditProductRequest): Promise<runtime.ApiResponse<MelcoCoreModelsProductResponse>> {
        if (requestParameters.productCode === null || requestParameters.productCode === undefined) {
            throw new runtime.RequiredError('productCode','Required parameter requestParameters.productCode was null or undefined when calling productsEditProduct.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/products/{product_code}`.replace(`{${"product_code"}}`, encodeURIComponent(String(requestParameters.productCode))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MelcoCoreModelsUpdateProductToJSON(requestParameters.melcoCoreModelsUpdateProduct),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoCoreModelsProductResponseFromJSON(jsonValue));
    }

    /**
     * edit product
     * edit product
     */
    async productsEditProduct(requestParameters: SystemManagementApiProductsEditProductRequest): Promise<MelcoCoreModelsProductResponse> {
        const response = await this.productsEditProductRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get list of products
     */
    async productsGetListRaw(requestParameters: SystemManagementApiProductsGetListRequest): Promise<runtime.ApiResponse<MelcoCoreModelsGenericList1MelcoCoreModelsProductListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoCoreModelsGenericList1MelcoCoreModelsProductListItemFromJSON(jsonValue));
    }

    /**
     * Get list of products
     */
    async productsGetList(requestParameters: SystemManagementApiProductsGetListRequest): Promise<MelcoCoreModelsGenericList1MelcoCoreModelsProductListItem> {
        const response = await this.productsGetListRaw(requestParameters);
        return await response.value();
    }

    /**
     * get list of product subscriptions.
     * get product subscriptions list
     */
    async productsGetModuleListRaw(requestParameters: SystemManagementApiProductsGetModuleListRequest): Promise<runtime.ApiResponse<MelcoCoreModelsGenericList1MelcoCoreModelsSubscriptionListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.productCodeList !== undefined) {
            queryParameters['product_code_list'] = requestParameters.productCodeList;
        }

        if (requestParameters.versionNumberList !== undefined) {
            queryParameters['version_number_list'] = requestParameters.versionNumberList;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products/subscriptions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoCoreModelsGenericList1MelcoCoreModelsSubscriptionListItemFromJSON(jsonValue));
    }

    /**
     * get list of product subscriptions.
     * get product subscriptions list
     */
    async productsGetModuleList(requestParameters: SystemManagementApiProductsGetModuleListRequest): Promise<MelcoCoreModelsGenericList1MelcoCoreModelsSubscriptionListItem> {
        const response = await this.productsGetModuleListRaw(requestParameters);
        return await response.value();
    }

    /**
     * get product
     * get product
     */
    async productsGetProductRaw(requestParameters: SystemManagementApiProductsGetProductRequest): Promise<runtime.ApiResponse<MelcoCoreModelsProductResponse>> {
        if (requestParameters.productCode === null || requestParameters.productCode === undefined) {
            throw new runtime.RequiredError('productCode','Required parameter requestParameters.productCode was null or undefined when calling productsGetProduct.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products/{product_code}`.replace(`{${"product_code"}}`, encodeURIComponent(String(requestParameters.productCode))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoCoreModelsProductResponseFromJSON(jsonValue));
    }

    /**
     * get product
     * get product
     */
    async productsGetProduct(requestParameters: SystemManagementApiProductsGetProductRequest): Promise<MelcoCoreModelsProductResponse> {
        const response = await this.productsGetProductRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get list of product version
     */
    async productsGetVersionListRaw(requestParameters: SystemManagementApiProductsGetVersionListRequest): Promise<runtime.ApiResponse<MelcoCoreModelsGenericList1MelcoCoreModelsProductVersionListItem>> {
        if (requestParameters.productCode === null || requestParameters.productCode === undefined) {
            throw new runtime.RequiredError('productCode','Required parameter requestParameters.productCode was null or undefined when calling productsGetVersionList.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products/{product_code}/versions`.replace(`{${"product_code"}}`, encodeURIComponent(String(requestParameters.productCode))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MelcoCoreModelsGenericList1MelcoCoreModelsProductVersionListItemFromJSON(jsonValue));
    }

    /**
     * Get list of product version
     */
    async productsGetVersionList(requestParameters: SystemManagementApiProductsGetVersionListRequest): Promise<MelcoCoreModelsGenericList1MelcoCoreModelsProductVersionListItem> {
        const response = await this.productsGetVersionListRaw(requestParameters);
        return await response.value();
    }

    /**
     * get pdf document
     * get pdf document
     */
    async productsPdfDocumentRaw(requestParameters: SystemManagementApiProductsPdfDocumentRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.productCode === null || requestParameters.productCode === undefined) {
            throw new runtime.RequiredError('productCode','Required parameter requestParameters.productCode was null or undefined when calling productsPdfDocument.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling productsPdfDocument.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.download !== undefined) {
            queryParameters['Download'] = requestParameters.download;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/products/{product_code}/documents/pdf/{Id}`.replace(`{${"product_code"}}`, encodeURIComponent(String(requestParameters.productCode))).replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * get pdf document
     * get pdf document
     */
    async productsPdfDocument(requestParameters: SystemManagementApiProductsPdfDocumentRequest): Promise<void> {
        await this.productsPdfDocumentRaw(requestParameters);
    }

}
